import * as React from 'react';

export const HamburgerSVG = (props) => {
    return (
        <svg viewBox="0 0 40 18" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M.285.19h39.39V1.2H.285zM.285 8.27h39.39v1.01H.285zM.285 16.35h39.39v1.01H.285z" />
        </svg>
    );
};
